/** 品牌色：暖金青铜（非蓝色），用于 Naive 主题与文档 */
export const palette = {
  light: {
    primary: '#8B7355',
    primaryHover: '#A68B62',
    primaryPressed: '#6F5A42',
    primarySuppl: '#C4A574',
    primaryRgb: '139, 115, 85',
    pageBg: '#F7F5F1',
    panelBg: '#FFFDFB',
    border: '#E8E2D8',
    textPrimary: '#2C2825',
    textSecondary: '#6B6560',
    info: '#6B6560',
    shadowRgb: '44, 40, 37'
  },
  dark: {
    primary: '#C9A86C',
    primaryHover: '#D9BC82',
    primaryPressed: '#A68B52',
    primarySuppl: '#E2C992',
    primaryRgb: '201, 168, 108',
    pageBg: '#161412',
    panelBg: '#22201C',
    border: '#3D3832',
    textPrimary: '#EDE8E0',
    textSecondary: '#A39E96',
    info: '#9A948C',
    shadowRgb: '0, 0, 0'
  }
}
